import React from "react";
import styles from "./Chat.module.css";
import ChatWindow from "./ChatWindow";
import firebase from "firebase/app";
import "firebase/firestore";
import AuthContext from "../../contexts/AuthContext";
import _ from "lodash";
import { AppContext } from "../../contexts/AppContext";

const Chat = () => {
  const defaultContacts = [];

  const [contacts, setContacts] = React.useState(defaultContacts);
  console.log(contacts);
  // const [threads, setThreads] = React.const [state, setstate] = useState(initialState)({});
  const [threads, dispatch] = React.useReducer(reducer, {});
  const [prevContacts, setPrevContacts] = React.useState([]);
  const [activeContacts, setActiveContacts] = React.useState([]);
  const { user, token } = React.useContext(AuthContext);
  const { setChat } = React.useContext(AppContext);
  const [showChatWindow, setShowChatWindow] = React.useState(true);
  // console.log(threads);
  const newChat = (contact) => {
    const chatIndex = activeContacts.indexOf(contact);
    if (chatIndex === -1) {
      setActiveContacts([...activeContacts, contact]);
    }
  };

  const getUser = async (uid) => {
    console.log(uid);
    const rawResponse = await fetch(`https://api.yazbie.com/api/users/${uid}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    const resp = await rawResponse.json();
    console.log(resp);
    if (resp.success) {
      return resp.user;
    }
  };

  const getUsers = async (userIds) => {
    const b = await Promise.all(
      userIds.map(async (u) => {
        const user = await getUser(u.uid);
        console.log(user);
        return {
          name: user.name,
          avatar_link: user.avatar_link,
          thread: u.thread,
        };
      })
    );
    setContacts(b);
  };

  const removeChat = (contact) => {
    const chatIndex = activeContacts.indexOf(contact);
    setActiveContacts([
      ...activeContacts.slice(0, chatIndex),
      ...activeContacts.slice(chatIndex + 1),
    ]);
    setChat(false);
  };

  const initContactListener = () => {
    const db = firebase.firestore();
    db.collection("chat")
      .where("users", "array-contains", user._id)

      .onSnapshot((snapshot) => {
        const userIds = snapshot.docs.map((item) => ({
          uid: item.data().users.filter((u) => u !== user._id)[0],
          thread: item.id,
        }));

        // const a = userIds.map(async (uid) => {
        //   const r = await getUser(uid);
        //   setContacts([...contacts, r]);
        // });
        console.log(userIds);
        getUsers(userIds);

        // for (const uid of userIds) {
        //   const a = (async () => {
        //     return await getUser(uid[0]);
        //   })();
        //   console.log(a);
        // }

        // TODO: from userIds get users and replace defaultContacts
        console.log(userIds);
        // setContacts(defaultContacts.slice(0, snapshot.size));
      });
  };

  const initThreadsListener = (newContacts) => {
    const db = firebase.firestore();
    newContacts.forEach((newContact) => {
      db.collection(`chat/${newContact.thread}/thread`)
        // .orderBy("time")
        .onSnapshot((snapshot) => {
          // const userIds = snapshot.docs.map((item) =>
          //   item.data().users.filter((u) => u !== user._id)
          // );
          // TODO: from userIds get users and replace defaultContacts

          const messages = snapshot.docs.map((item) => item.data());

          if (
            messages.length > 0 &&
            messages[0].user &&
            threads[newContact.thread]
          ) {
            dispatch({
              type: "add",
              id: newContact.thread,
              data: messages,
            });
          } else if (
            messages.length > 0 &&
            messages[0].user &&
            !threads[newContact.thread]
          ) {
            snapshot.docChanges().forEach((ch) => {
              dispatch({
                type: "add",
                id: newContact.thread,
                data: [ch.doc.data()],
              });
            });
          }
        });
    });
  };

  React.useEffect(() => {
    if (user) {
      initContactListener();
    }
  }, [user]);

  React.useEffect(() => {
    const newContacts = contacts.filter((item) => !_.find(prevContacts, item));
    if (newContacts.length !== 0) {
      initThreadsListener(newContacts);
    }
  }, [contacts]);

  return (
    <div className={styles.chat}>
      {(window.innerWidth >= 720 || showChatWindow) && 
        <ChatWindow
          contacts={contacts}
          newChat={newChat}
          removeChat={() => {
            setShowChatWindow(false);
            // setChat(false);
            // setActiveContacts([]);
          }}
        />
      }
      {activeContacts.map((contact, i) => (
        <ChatWindow
          contact={contact}
          thread={threads[contact.thread]}
          removeChat={removeChat}
          user={user}
        />
      ))}
    </div>
  );
};

function reducer(state, action) {
  switch (action.type) {
    case "add":
      if (state[action.id]) {
        return {
          ...state,
          [action.id]: [...state[action.id], ...action.data],
        };
      } else {
        return {
          ...state,
          [action.id]: action.data,
        };
      }

    case "decrement":
      return { count: state.count - 1 };
    default:
      throw new Error();
  }
}

export default Chat;
